import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Logo } from 'components';

import { Image } from 'semantic-ui-react';

import classNames from 'classnames/bind';
import styles from './LoginTemplate.css';
const cx = classNames.bind(styles);

// 로그인에서 공통으로 사용하는 배경 템플릿
const LoginTemplate = ({ children, extraArea, isHideLogo, loginPage }) => {
  return (
    <div className={cx('loginTemplate-wrapper', { loginPage })}>
      <Image src={'/img/common/login_back.png'} />
      <div className={cx('loginTemplate-area')}>
        {/* 로고 */}
        {!isHideLogo && (
          <div className={cx('logo-area')}>
            <Logo color="white" size="wide" />
          </div>
        )}
        {/* 내용 영역 */}
        <div className={cx('content-area')}>{children}</div>
        {extraArea}
      </div>
    </div>
  );
};

export default LoginTemplate;



// WEBPACK FOOTER //
// ./src/script/components/template/LoginTemplate.js